import React from "react";
import {QuestionsTable} from "./components/patterns/QuestionsTable";
import CreateQuestionButton from "./components/atoms/CreateQuestionButton/CreateQuestionButton";
import {Grid} from "@mui/material";
import {FeatureAppearance} from "../FeatureAppearance";

export default function Questions() {
    return (
        <div style={{ width: "100%" }}>
          <FeatureAppearance feature={["questions.questions.any.create"]}>
            {(featureExist) => {
              return featureExist
              ? (
                <Grid container sx={theme => ({ padding: theme.spacing(2, 0) })}>
                  <CreateQuestionButton/>
                </Grid>
              ) : null;
            }}
          </FeatureAppearance>
          <QuestionsTable/>
        </div>
    )
}